var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.authenticated)?_c('h3',{staticClass:"mouse-hover mt-4 text-muted",on:{"click":_vm.setWelcomeMessage}},[_vm._v(" "+_vm._s(_vm.welcomeMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }